document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pt-cookie-settings]');
  if (!button) return;
  event.preventDefault();
  const error = button.parentElement.querySelector('[data-pt-cookie-error]');
  if (error) error.hidden = true;
  try {
    if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
    await window.privacyBanner.showPreferences();
  } catch {
    if (error) error.hidden = false;
  }
});

(() => {
  const source = document.getElementById('pt-cookie-translations');
  if (!source) return;
  const text = JSON.parse(source.textContent);
  const replaceText = (selector, key) => {
    const element = document.querySelector(selector);
    if (!element || !text[key]) return;
    const node = Array.from(element.childNodes).find(child => child.nodeType === Node.TEXT_NODE && child.textContent.trim());
    if (node && node.textContent !== text[key]) node.textContent = text[key];
  };
  const translate = () => {
    replaceText('#shopify-pc__banner__body-title', 'banner_title');
    replaceText('#shopify-pc__banner .shopify-pc__banner__body p', 'banner_text');
    replaceText('#shopify-pc__banner__body-policy-link', 'policy');
    replaceText('#shopify-pc__banner__btn-manage-prefs span', 'manage');
    replaceText('#shopify-pc__banner__btn-accept', 'accept');
    replaceText('#shopify-pc__banner__btn-decline', 'decline');
    replaceText('#shopify-pc__prefs__header-title', 'title');
    replaceText('#shopify-pc__prefs__header-accept', 'accept_all');
    replaceText('#shopify-pc__prefs__header-decline', 'decline_all');
    replaceText('#shopify-pc__prefs__header-save', 'save');
    replaceText('#shopify-pc__prefs .shopify-pc__prefs__intro-main h3', 'intro_title');
    replaceText('#shopify-pc__prefs .shopify-pc__prefs__intro-main p', 'intro_text');
    for (const key of ['essential', 'preferences', 'marketing', 'analytics']) {
      replaceText('#shopify-pc__prefs__' + key + ' label', key);
      replaceText('#shopify-pc__prefs__' + key + ' p', key + '_text');
    }
    const close = document.getElementById('shopify-pc__prefs__header-close');
    if (close) close.setAttribute('aria-label', text.close);
    for (const id of ['shopify-pc__banner', 'shopify-pc__prefs__dialog']) {
      const element = document.getElementById(id);
      if (element) { element.setAttribute('lang', 'ar'); element.setAttribute('dir', 'rtl'); }
    }
  };
  const selector = '#shopify-pc__banner, #shopify-pc__prefs';
  new MutationObserver(records => {
    const relevant = records.some(record =>
      record.target.parentElement?.closest(selector) ||
      (record.target.nodeType === Node.ELEMENT_NODE && record.target.matches(selector)) ||
      Array.from(record.addedNodes).some(node => node.nodeType === Node.ELEMENT_NODE && (node.matches(selector) || node.querySelector(selector)))
    );
    if (relevant) translate();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  translate();
})();
